import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { IPromotion } from '~/types/promotion';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectExpansionsNFTPromoBar',
  props: {
    promo: null
  },
  setup(__props: any) {

const props = __props as {
  promo: IPromotion;
};



const { $vuetify } = useContext();

return { __sfc: true,props, $vuetify }
}

})